import { render, staticRenderFns } from "./Especies.vue?vue&type=template&id=8ff2e2f0&scoped=true&"
import script from "./Especies.vue?vue&type=script&lang=js&"
export * from "./Especies.vue?vue&type=script&lang=js&"
import style0 from "./Especies.vue?vue&type=style&index=0&id=8ff2e2f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff2e2f0",
  null
  
)

export default component.exports